export default {
  top(el) {
    return el.getBoundingClientRect().top
      + window.pageYOffset || document.documentElement.scrollTop;
  },
};
